import React from "react";
import { SearchBox, PoweredBy } from "react-instantsearch-dom";

const Search = () => {
  return (
    <div>
      <SearchBox />
      <PoweredBy />
    </div>
  );
};

export default Search;
